export default __webpack_public_path__ + "static/media/lazada.019ad93c.png";